var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-spinner": "none",
        "element-loading-background": "rgba(170,170,170,0)"
      }
    },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: { "config-module": "920" },
                on: {
                  "click-more": function(value) {
                    _vm.isAdvancedQuery = value
                  },
                  simSearchItemCallBack: function($event) {
                    return _vm.toAdvancedQuery()
                  },
                  advSearchItemCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { display: "flex" },
                    attrs: { slot: "operations" },
                    slot: "operations"
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100px", "margin-left": "5px" },
                        attrs: { filterable: "" },
                        on: { change: _vm.onTimeRangeChange },
                        model: {
                          value: _vm.timeRange,
                          callback: function($$v) {
                            _vm.timeRange = $$v
                          },
                          expression: "timeRange"
                        }
                      },
                      _vm._l(_vm.TIME_RANGES, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.isZh
                              ? item.chineseName
                              : item.englishName,
                            value: item.code
                          }
                        })
                      }),
                      1
                    ),
                    _c("el-date-picker", {
                      staticStyle: { width: "120px", margin: "0 5px" },
                      attrs: {
                        disabled: _vm.timeRange !== _vm.CUSTOM.code,
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        editable: false,
                        clearable: false
                      },
                      model: {
                        value: _vm.commonFilter.start,
                        callback: function($$v) {
                          _vm.$set(_vm.commonFilter, "start", $$v)
                        },
                        expression: "commonFilter.start"
                      }
                    }),
                    _vm._v("- "),
                    _c("el-date-picker", {
                      staticStyle: { width: "120px", "margin-left": "5px" },
                      attrs: {
                        disabled: _vm.timeRange !== _vm.CUSTOM.code,
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        editable: false,
                        clearable: false
                      },
                      model: {
                        value: _vm.commonFilter.end,
                        callback: function($$v) {
                          _vm.$set(_vm.commonFilter, "end", $$v)
                        },
                        expression: "commonFilter.end"
                      }
                    }),
                    _c("span", { staticStyle: { "padding-left": "10px" } }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.PortOfLoading")))
                    ]),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "150px", margin: "0 5px" },
                      attrs: {
                        "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                        filterable: "",
                        "default-multiple-value": _vm.commonFilter.pol,
                        placeholder: ""
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.commonFilter.pol = p.value
                        }
                      }
                    }),
                    _c("span", { staticStyle: { "padding-left": "10px" } }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.PortOfDestination")))
                    ]),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "150px", margin: "0 5px" },
                      attrs: {
                        "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                        filterable: "",
                        "default-multiple-value": _vm.commonFilter.pod,
                        placeholder: ""
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.commonFilter.pol = p.value
                        }
                      }
                    }),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { margin: "0 5px 0 15px" },
                        on: { change: _vm.resetTimer },
                        model: {
                          value: _vm.autoRefresh,
                          callback: function($$v) {
                            _vm.autoRefresh = $$v
                          },
                          expression: "autoRefresh"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AutomaticallyRefresh")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: { "min-height": "350px" }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "check-main-record": false,
                    "deselect-main-record": false,
                    "auto-fit-content": false
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("booking-dialog", {
        attrs: {
          visible: _vm.bookingDialog.visible,
          flight: _vm.bookingDialog.flight,
          jobs: _vm.bookingDialog.jobs
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.bookingDialog, "visible", $event)
          }
        }
      }),
      _c("query-mbl-dialog", {
        attrs: { visible: _vm.queryMblDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.queryMblDialog, "visible", $event)
          },
          callback: _vm.queryMblCallback
        }
      }),
      _c("mix-flight-dialog", {
        attrs: {
          visible: _vm.mixFlightDialog.visible,
          jobs: _vm.mixFlightDialog.jobs
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.mixFlightDialog, "visible", $event)
          },
          callback: function($event) {
            return _vm.toAdvancedQuery()
          }
        }
      }),
      _c("loading-note-dialog", {
        attrs: {
          visible: _vm.loadingNoteDialog.visible,
          jobs: _vm.loadingNoteDialog.jobs
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.loadingNoteDialog, "visible", $event)
          },
          callback: function($event) {
            return _vm.gridApi.setRowData(_vm.rowData)
          }
        }
      }),
      _c("warehouse-entry-dialog", {
        attrs: {
          visible: _vm.warehouseEntryDialog.visible,
          job: _vm.warehouseEntryDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.warehouseEntryDialog, "visible", $event)
          },
          callback: function($event) {
            return _vm.toAdvancedQuery()
          }
        }
      }),
      _c("booking-done-dialog", {
        attrs: {
          visible: _vm.bookingDoneDialog.visible,
          flight: _vm.bookingDoneDialog.flight
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.bookingDoneDialog, "visible", $event)
          }
        }
      }),
      _c("declare-customs-dialog", {
        attrs: {
          visible: _vm.declareCustomsDialog.visible,
          job: _vm.declareCustomsDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.declareCustomsDialog, "visible", $event)
          }
        }
      }),
      _c("operator-remark-dialog", {
        attrs: {
          visible: _vm.operatorRemarkDialog.visible,
          "operator-id": _vm.operatorRemarkDialog.operatorId,
          job: _vm.operatorRemarkDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.operatorRemarkDialog, "visible", $event)
          },
          callback: function($event) {
            return _vm.gridApi.setRowData(_vm.rowData)
          }
        }
      }),
      _c("update-flight-dialog", {
        attrs: {
          visible: _vm.updateFlightDialog.visible,
          operation: _vm.updateFlightDialog.operation,
          flight: _vm.updateFlightDialog.flight
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.updateFlightDialog, "visible", $event)
          },
          callback: function($event) {
            return _vm.gridApi.setRowData(_vm.rowData)
          }
        }
      }),
      _c("deliver-agent-dialog", {
        attrs: {
          visible: _vm.deliverAgentDialog.visible,
          jobs: _vm.deliverAgentDialog.jobs
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.deliverAgentDialog, "visible", $event)
          }
        }
      }),
      _c("upload-loading-pic-dialog", {
        attrs: {
          visible: _vm.uploadLoadingPicDialog.visible,
          job: _vm.uploadLoadingPicDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.uploadLoadingPicDialog, "visible", $event)
          }
        }
      }),
      _c("warehouse-label-dialog", {
        attrs: {
          visible: _vm.warehouseLabelDialog.visible,
          job: _vm.warehouseLabelDialog.job,
          "warehouse-in": _vm.warehouseLabelDialog.warehouseIn
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.warehouseLabelDialog, "visible", $event)
          },
          callback: _vm.onWarehouseLabelChange
        }
      }),
      _c("billingDialog", {
        attrs: {
          visible: _vm.billingDialog.visible,
          job: _vm.billingDialog.job,
          "doc-type": _vm.billingDialog.docType
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billingDialog, "visible", $event)
          },
          callback: _vm.delayUpdateButtonState
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }